import { mix } from "@chorda/core";
export const Fields = (props) => {
    return mix({
        css: 'field is-horizontal',
        templates: {
            label: {
                weight: -10,
                css: 'field-label',
                templates: {
                    label: {
                        tag: 'label',
                        css: 'label',
                    }
                }
            },
            body: {
                css: 'field-body',
            }
        }
    }, props && {
        components: {
            body: true,
            label: props.label != null
        },
        templates: {
            label: {
                classes: {
                    [props.labelSize]: true,
                    'is-normal': true
                },
                templates: {
                    label: {
                        text: props.label
                    }
                }
            },
            body: {
                items: props.fields
            }
        }
    });
};
